module.exports = __webpack_public_path__ + "static/media/Goblin-Selected.0d04e21e.png";